import React, { useState, useRef } from 'react'
import { Table, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import Fetch from '@components/CRUD/Fetch'
import ListOperation from '@components/CRUD/ListOperation'
import { client } from '@utils/client'

const List = () => {
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const { t } = useLocalization()

  const handleReload = () => {
    fetchRef.current.reload()
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const fetch = async () => {
    const result = await client
      .get('/hospital', {
        params: {
          skip: (page - 1) * pageSize,
          limit: pageSize,
        },
      })
      .then((res) => res.data)
    return result
  }

  const columns = [
    {
      title: t('hospital.listScreen.column.name'),
      dataIndex: 'name',
      key: 'name',
      width: '20%',
    },
    {
      title: t('hospital.listScreen.column.location'),
      dataIndex: 'location',
      key: 'location',
      width: '25%',
    },
    {
      title: t('hospital.listScreen.column.availableTime'),
      dataIndex: 'availableTime',
      key: 'availableTime',
      width: '20%',
    },
    {
      title: t('hospital.listScreen.column.telemedUrl'),
      dataIndex: 'telemedUrl',
      key: 'telemedUrl',
      width: '20%',
      render: function TelemedUrl(text) {
        return (
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        )
      },
    },
    {
      title: t('hospital.listScreen.column.action'),
      width: '15%',
      render: function Action(record) {
        return (
          <ListOperation
            row={record}
            basePath="/hospitals"
            deletePath={`/hospital/${record.id}`}
            handleReload={handleReload}
          />
        )
      },
    },
  ]

  return (
    <Fetch fetch={fetch} params={{ page, pageSize }} ref={fetchRef}>
      {({ data, total }) => (
        <PageLayout
          title={t('hospital.listScreen.title')}
          createPath="/hospitals/create"
          shownBack={false}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('hospital.listScreen.reload')}
            </Button>,
          ]}
        >
          <Table
            rowKey="id"
            onChange={handleChange}
            columns={columns}
            dataSource={data}
            pagination={{
              defaultCurrent: defaultPageSize,
              defaultPageSize: defaultPageSize,
              current: page,
              pageSize,
              total,
            }}
          />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default List
